export function scrollToId(id, offset = 84) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lenis = window.__lenis;
  if (lenis && !reduce) {
    lenis.scrollTo(el, { offset: -offset });
    return;
  }
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
}
